





































import BaseComponent from "@/components/base/BaseComponent";
import {MemberType} from "@/components/dashboard/process-management/model/ProcessManagmentTypes";
import {Component} from 'vue-property-decorator';

@Component({})
export default class MoneyWithdrawalSmallAmountProvidentFund extends BaseComponent {

  private smallAmountRewardMoneyFlag: boolean = true
  private smallAmountCompensationMoneyFlag: boolean = false
  private endEmploymentDate: any = ''
  private employerName: string = ''
  private showCheckBoxSection: boolean = true

  private smallAmountProcessRequest: any = {}

  mounted() {
    this.smallAmountProcessRequest = {
      withdrawalType: 0,
      withdrawalTypeDate: this.endEmploymentDate,
      withdrawalTypeEmployerName: this.employerName,
      memberStatusType: MemberType.SMALL_AMOUNT
    }

    this.$emit('updateChanges', this.smallAmountProcessRequest)
  }

  handleSmallAmountRewardMoneyFlag(input: any) {
    this.showCheckBoxSection = false
    this.smallAmountCompensationMoneyFlag = !input

    this.smallAmountProcessRequest = {
      ...this.smallAmountProcessRequest,
      withdrawalType: 0
    }

    this.$emit('updateChanges', this.smallAmountProcessRequest)

    setTimeout(() => this.showCheckBoxSection = true, 0)
  }

  handleSmallAmountCompensationMoneyFlagChanged(input: any) {
    this.showCheckBoxSection = false
    this.smallAmountRewardMoneyFlag = !input

    this.smallAmountProcessRequest = {
      ...this.smallAmountProcessRequest,
      withdrawalType: 1
    }

    this.$emit('updateChanges', this.smallAmountProcessRequest)

    setTimeout(() => this.showCheckBoxSection = true, 0)
  }

  handleEndEmploymentDateChanged(input: any) {
    this.smallAmountProcessRequest = {
      ...this.smallAmountProcessRequest,
      withdrawalTypeDate: input
    }

    this.$emit('updateChanges', this.smallAmountProcessRequest)
  }

  handleEmployerNameChanged(input: any) {
    this.smallAmountProcessRequest = {
      ...this.smallAmountProcessRequest,
      withdrawalTypeEmployerName: input
    }

    this.$emit('updateChanges', this.smallAmountProcessRequest)
  }

}
